import Api from "./Api";
import Utils from "../utilities/Utils";
import { Widget } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class WidgetsController extends Api {
  static getWidget(id: string) {
    return fetch(`/api/widgets/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getWidgets(params: object) {
    return fetch(`/api/widgets?${SearchHelper.getQueryString(params)}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(widget: Widget) {
    return fetch("/api/widgets", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ widget: widget }),
    }).then((res) => res.json());
  }

  static update(widget: Widget) {
    return fetch(`/api/widgets/${widget.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ widget: widget }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/widgets/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static bulkDelete(widgetIds: string[]) {
    return fetch(`/api/widgets/destroy_all`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ widget_ids: widgetIds }),
    }).then((res) => res.json());
  }

  static getForm(params: { id?: string }) {
    return fetch(`/api/widgets/form?${Utils.encodeQueryData(params)}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getView(widgetId: string, params = {}): Promise<{ widget: Widget }> {
    return fetch(
      `/api/widgets/${widgetId}/view?${Utils.encodeQueryData(params)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
